import React, { useState, useEffect, useRef } from "react";

const tigerSize = 70;
const pipeWidth = 50;
const gap = 200;

interface Obstacle {
  x: number;
  topHeight: number;
  passed: boolean;
}

export default function BaksoTigerGame(): JSX.Element {
  const [tigerY, setTigerY] = useState(200);
  const [obstacles, setObstacles] = useState<Obstacle[]>([]);
  const [score, setScore] = useState(0);
  const [isGameOver, setIsGameOver] = useState(false);
  const velocity = useRef(0);
  const gravity = 0.5;
  const jumpStrength = -7;
  const speed = useRef(2);
  const [showLevelUp, setShowLevelUp] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      velocity.current += gravity;
      setTigerY((prev) => {
        const newY = prev + velocity.current;
        const maxY = window.innerHeight - tigerSize;
        return Math.max(Math.min(newY, maxY), 0);
      });
    }, 20);
    return () => clearInterval(interval);
  }, []);

  const handleJump = () => {
    if (isGameOver) {
      setObstacles([]);
      setScore(0);
      setIsGameOver(false);
      velocity.current = 0;
      setTigerY(200);
      speed.current = 2;
      return;
    }
    velocity.current = jumpStrength;
  };
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.code === "Space") {
        event.preventDefault();
        handleJump();
      }
    };
  
    window.addEventListener("keydown", handleKeyDown);
  
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isGameOver]);
  useEffect(() => {
    const spawn = setInterval(() => {
      if (isGameOver) return;
      const topHeight =
        Math.floor(Math.random() * (window.innerHeight - gap - 200)) + 100;
      setObstacles((prev) => [
        ...prev,
        { x: 500, topHeight, passed: false },
      ]);
    }, 2100);
    return () => clearInterval(spawn);
  }, [isGameOver]);

  useEffect(() => {
    const mover = setInterval(() => {
      if (isGameOver) return;
      setObstacles((prev) => {
        const updated = prev
          .map((obs) => ({ ...obs, x: obs.x - speed.current }))
          .filter((obs) => obs.x + pipeWidth > 0);

        updated.forEach((obs) => {
          if (!obs.passed && obs.x + pipeWidth < 100) {
            obs.passed = true;
            setScore((prevScore) => {
              const newScore = prevScore + 1;
              if (newScore % 10 === 0) {
                speed.current *= 1.40;
                setShowLevelUp(true);
                setTimeout(() => setShowLevelUp(false), 1200);
              }
              return newScore;
            });
          }
        });

        return updated;
      });
    }, 20);
    return () => clearInterval(mover);
  }, [isGameOver]);

  useEffect(() => {
    obstacles.forEach((obs) => {
      const tigerLeft = 110;
      const tigerRight = 100 + tigerSize - 10;
      const inX = tigerRight > obs.x && tigerLeft < obs.x + pipeWidth;
      const hitTop = tigerY + 10 < obs.topHeight;
      const hitBottom = tigerY + tigerSize - 10 > obs.topHeight + gap;

      if (inX && (hitTop || hitBottom)) {
        setIsGameOver(true);
      }
    });
  }, [obstacles, tigerY]);

  return (
    <div
      className={`game-container ${showLevelUp ? "level-up" : ""}`}
      onClick={handleJump}
    >
      {" "}
      <img src="/jungle-bg.png" alt="Background" className="background" />{" "}
      <img
        src="/tiger2.png"
        alt="Tiger"
        className="tiger"
        style={{
          top: `${tigerY}px`,
          left: "100px",
          width: `${tigerSize}px`,
          height: `${tigerSize}px`,
        }}
      />
      {obstacles.map((obs, i) => (
        <React.Fragment key={i}>
          <div
            className="obstacle"
            style={{
              left: obs.x,
              top: 0,
              height: obs.topHeight,
              width: pipeWidth,
            }}
          />
          <div
            className="obstacle bottom"
            style={{
              left: obs.x,
              top: obs.topHeight + gap,
              height: window.innerHeight - obs.topHeight - gap,
              width: pipeWidth,
            }}
          />
        </React.Fragment>
      ))}
      <div className={`score ${showLevelUp ? "score-flash" : ""}`}>
  Score: {score} | Level: {Math.floor(score / 10) + 1}
</div>
      {isGameOver && <div className="game-over">Game Over! Tap to restart</div>}
      <button className="jump-button" onClick={handleJump}>
  JUMP / SPACEBAR
</button>
    </div>
  );
}
